import { render } from "./wxDetail.vue?vue&type=template&id=0d64bf42&scoped=true"
import script from "./wxDetail.vue?vue&type=script&lang=js"
export * from "./wxDetail.vue?vue&type=script&lang=js"

import "./wxDetail.vue?vue&type=style&index=0&id=0d64bf42&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ydsk-ph-h5-bankv3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d64bf42"]])

export default __exports__